import { render, staticRenderFns } from "./couture.vue?vue&type=template&id=b9b93fec&scoped=true"
import script from "./couture.vue?vue&type=script&lang=js"
export * from "./couture.vue?vue&type=script&lang=js"
import style0 from "./couture.vue?vue&type=style&index=0&id=b9b93fec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b93fec",
  null
  
)

export default component.exports